// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';


export type FirebaseSitesForSiteIdQueryVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type FirebaseSitesForSiteIdQuery = (
  { __typename?: 'Query' }
  & { firebaseSitesForSiteId?: Types.Maybe<(
    { __typename?: 'FirebaseResults' }
    & Pick<Types.FirebaseResults, 'error' | 'reauthorize'>
    & { items?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'FirebaseSite' }
      & Pick<Types.FirebaseSite, 'id' | 'name'>
    )>>> }
  )> }
);

export type GoogleAuthAddedSubscriptionVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
}>;


export type GoogleAuthAddedSubscription = (
  { __typename?: 'Subscription' }
  & Pick<Types.Subscription, 'googleAuthAdded'>
);


export const FirebaseSitesForSiteIdDocument = gql`
    query FirebaseSitesForSiteId($siteId: UUID!) {
  firebaseSitesForSiteId(siteId: $siteId) {
    items {
      id
      name
    }
    error
    reauthorize
  }
}
    `;

/**
 * __useFirebaseSitesForSiteIdQuery__
 *
 * To run a query within a React component, call `useFirebaseSitesForSiteIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useFirebaseSitesForSiteIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFirebaseSitesForSiteIdQuery({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useFirebaseSitesForSiteIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FirebaseSitesForSiteIdQuery, FirebaseSitesForSiteIdQueryVariables>) {
        return ApolloReactHooks.useQuery<FirebaseSitesForSiteIdQuery, FirebaseSitesForSiteIdQueryVariables>(FirebaseSitesForSiteIdDocument, baseOptions);
      }
export function useFirebaseSitesForSiteIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FirebaseSitesForSiteIdQuery, FirebaseSitesForSiteIdQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<FirebaseSitesForSiteIdQuery, FirebaseSitesForSiteIdQueryVariables>(FirebaseSitesForSiteIdDocument, baseOptions);
        }
export type FirebaseSitesForSiteIdQueryHookResult = ReturnType<typeof useFirebaseSitesForSiteIdQuery>;
export type FirebaseSitesForSiteIdLazyQueryHookResult = ReturnType<typeof useFirebaseSitesForSiteIdLazyQuery>;
export type FirebaseSitesForSiteIdQueryResult = ApolloReactCommon.QueryResult<FirebaseSitesForSiteIdQuery, FirebaseSitesForSiteIdQueryVariables>;
export const GoogleAuthAddedDocument = gql`
    subscription GoogleAuthAdded($siteId: UUID!) {
  googleAuthAdded(siteId: $siteId)
}
    `;

/**
 * __useGoogleAuthAddedSubscription__
 *
 * To run a query within a React component, call `useGoogleAuthAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGoogleAuthAddedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGoogleAuthAddedSubscription({
 *   variables: {
 *      siteId: // value for 'siteId'
 *   },
 * });
 */
export function useGoogleAuthAddedSubscription(baseOptions?: ApolloReactHooks.SubscriptionHookOptions<GoogleAuthAddedSubscription, GoogleAuthAddedSubscriptionVariables>) {
        return ApolloReactHooks.useSubscription<GoogleAuthAddedSubscription, GoogleAuthAddedSubscriptionVariables>(GoogleAuthAddedDocument, baseOptions);
      }
export type GoogleAuthAddedSubscriptionHookResult = ReturnType<typeof useGoogleAuthAddedSubscription>;
export type GoogleAuthAddedSubscriptionResult = ApolloReactCommon.SubscriptionResult<GoogleAuthAddedSubscription>;
